import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockActionSelectorComponent } from './block-action-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [BlockActionSelectorComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
  ],
  exports: [BlockActionSelectorComponent],
})
export class BlockActionSelectorModule {}
